module.exports = __webpack_public_path__ + "static/media/214-Sturz-Milo_ID_6.97941abf.mp3";